<template>
  <transition name="cookie-fade">
    <div
      v-if="!consentState.decided && authState.isAuthenticated"
      class="cookie-banner"
      role="dialog"
      aria-live="polite"
      :aria-label="$t('cookies.title')"
    >
      <div class="cookie-banner__content">
        <h2 class="cookie-banner__title">{{ $t("cookies.title") }}</h2>
        <p class="cookie-banner__message">
          {{ $t("cookies.message") }}
          <router-link to="/privacy" class="cookie-banner__link">
            {{ $t("cookies.learnMore") }}
          </router-link>
        </p>
        <p class="cookie-banner__warning">
          {{ $t("cookies.under16Warning") }}
        </p>
      </div>
      <div class="cookie-banner__actions">
        <button
          type="button"
          class="cookie-banner__btn cookie-banner__btn--settings"
          :aria-label="$t('cookies.settingsLabel')"
          @click="openSettings"
        >
          <span aria-hidden="true">⚙</span>
          <span class="cookie-banner__btn-label">
            {{ $t("cookies.settingsLabel") }}
          </span>
        </button>
        <button
          type="button"
          class="cookie-banner__btn cookie-banner__btn--reject"
          @click="reject"
        >
          {{ $t("cookies.rejectLabel") }}
        </button>
        <button
          type="button"
          class="cookie-banner__btn cookie-banner__btn--accept"
          @click="accept"
        >
          {{ $t("cookies.acceptLabel") }}
        </button>
      </div>
    </div>
  </transition>
</template>

<script>
import {
  consentState,
  acceptAllCookies,
  rejectAllCookies,
  openCookieSettings,
} from "../stores/consentStore";
import { authState } from "../stores/authStore";

export default {
  name: "CookieBanner",
  data() {
    return { consentState, authState };
  },
  methods: {
    accept() {
      acceptAllCookies();
    },
    reject() {
      rejectAllCookies();
    },
    openSettings() {
      openCookieSettings();
    },
  },
};
</script>

<style scoped>
.cookie-banner {
  position: fixed;
  left: 16px;
  right: 16px;
  bottom: 16px;
  max-width: 720px;
  margin: 0 auto;
  padding: 16px 20px;
  border-radius: 14px;
  background: rgba(20, 20, 22, 0.96);
  color: #fff;
  box-shadow: 0 12px 40px rgba(0, 0, 0, 0.35);
  display: flex;
  flex-direction: column;
  gap: 12px;
  z-index: 9999;
  backdrop-filter: blur(12px);
  -webkit-backdrop-filter: blur(12px);
  font-size: 14px;
  line-height: 1.45;
}

.cookie-banner__title {
  margin: 0 0 4px 0;
  font-size: 15px;
  font-weight: 600;
}

.cookie-banner__message {
  margin: 0;
  color: rgba(255, 255, 255, 0.82);
}

.cookie-banner__warning {
  margin: 6px 0 0 0;
  font-weight: 700;
  color: #fff;
}

.cookie-banner__link {
  color: #ffcc02;
  text-decoration: underline;
  margin-left: 4px;
}

.cookie-banner__actions {
  display: flex;
  gap: 10px;
  justify-content: flex-end;
  flex-wrap: wrap;
  align-items: center;
}

.cookie-banner__btn {
  padding: 9px 18px;
  border-radius: 999px;
  border: none;
  font-weight: 600;
  font-size: 14px;
  cursor: pointer;
  transition: opacity 0.15s ease, transform 0.05s ease;
}

.cookie-banner__btn:active {
  transform: scale(0.97);
}

.cookie-banner__btn--settings {
  background: transparent;
  color: rgba(255, 255, 255, 0.82);
  border: 1px solid rgba(255, 255, 255, 0.25);
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 9px 14px;
}

.cookie-banner__btn--settings:hover {
  background: rgba(255, 255, 255, 0.08);
  color: #fff;
}

.cookie-banner__btn--reject {
  background: rgba(255, 255, 255, 0.12);
  color: #fff;
}

.cookie-banner__btn--reject:hover {
  background: rgba(255, 255, 255, 0.18);
}

.cookie-banner__btn--accept {
  background: #ffcc02;
  color: #111;
}

.cookie-banner__btn--accept:hover {
  opacity: 0.92;
}

@media (min-width: 720px) {
  .cookie-banner {
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
  }
  .cookie-banner__content {
    flex: 1;
  }
  .cookie-banner__actions {
    margin-left: 12px;
  }
}

@media (max-width: 480px) {
  .cookie-banner__btn-label {
    display: none;
  }
  .cookie-banner__btn--settings {
    padding: 9px 12px;
  }
}

.cookie-fade-enter-active,
.cookie-fade-leave-active {
  transition: opacity 0.25s ease, transform 0.25s ease;
}
.cookie-fade-enter-from,
.cookie-fade-leave-to {
  opacity: 0;
  transform: translateY(20px);
}
</style>
